import { RefObject, useEffect } from "react";

export function useScrollToBottom(ref: RefObject<HTMLElement>, deps?: any[]) {
  useEffect(() => ref.current?.scrollTo(0, ref.current?.scrollHeight), deps);
}